import { render, staticRenderFns } from "./LegacyMain.vue?vue&type=template&id=ddea662a"
import script from "./LegacyMain.vue?vue&type=script&lang=js"
export * from "./LegacyMain.vue?vue&type=script&lang=js"
import style0 from "./LegacyMain.vue?vue&type=style&index=0&id=ddea662a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports